import React, { useMemo } from 'react';

export const withStaticOptions = C => ({ options, loadOptions: loadOptionsProp, debounceTimeout: debounceTimeoutProp, ...rest }) => {
  const loadOptions = useMemo(() => {
    if (loadOptionsProp) return loadOptionsProp;
    if (!options) return async () => [];

    if (Array.isArray(options)) {
      if (options.every(o => Array.isArray(o && o.options))) {
        return async (filter) => {
          return options.map(group => ({ ...group, options: group.options.filter(o => typeof o.label === 'string' && o.label.toLowerCase().includes(filter.toLowerCase())) }));
        };
      }

      return async (filter) => {
        return options.filter(o => typeof o.label === 'string' && o.label.toLowerCase().includes(filter.toLowerCase()));
      };
    }

    let optionsFn = options;

    // Is options a Promise?
    if (typeof options.then === 'function') {
      options.catch(() => {
        // Real error handler will be attached later, when optionsFn is called.
        // but if promise rejects before that, we will have an "unhandled promise rejection"
        // unless attach this no-op handler.
        // no need to return anything from here because the return promise is not saved anywhere
      });
      optionsFn = () => options;
    }

    if (typeof optionsFn === 'function') {
      let memoResponse = undefined;
      return async (filter) => {
        memoResponse = memoResponse || optionsFn(filter);
        const data = await memoResponse;
        return data.filter(
          o => typeof o.label === 'string'
            && o.label.toLowerCase().includes(filter.toLowerCase())
        );
      };
    }

    throw new Error(`Unexpected options value. must be function or array. got ${typeof options}: ${JSON.stringify(options)}`);
  }, [loadOptionsProp, options]);

  const debounceTimeout = useMemo(() => {
    if (loadOptionsProp) return debounceTimeoutProp;
    return 0;
  }, [debounceTimeoutProp, loadOptionsProp]);

  return (
    <C
      loadOptions={loadOptions}
      debounceTimeout={debounceTimeout}
      eagerOptionsLoad={Array.isArray(options)}
      {...rest}
    />
  );
};
